import { Component, computed, inject, input, signal } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, LoaderComponent } from '@camelot/ui';

import { CamGridCursorService } from '../../services/grid-cursor.service';
import { CamTranslationGrid } from '../../translation.service';
import { AbstractGridComponent } from '../abstract-grid.component';

type Type = 'next' | 'previous';

@Component({
  selector: 'cam-grid-cursor',
  imports: [ButtonComponent, LoaderComponent, TranslatePipe],
  templateUrl: './grid-cursor.component.html',
  styleUrl: './grid-cursor.component.scss',
})
export class GridCursorComponent extends AbstractGridComponent<any> {
  navigation = input.required<(id: string) => void>();

  get grid() {
    return this._grid;
  }

  public readonly cursorList = signal<{ id: string }[]>([]);
  public readonly hasPrevious = computed(() => !!this._getId('previous'));
  public readonly hasNext = computed(() => !!this._getId('next'));

  private readonly _cursorServices = inject(CamGridCursorService);

  protected override _createGrid = false;

  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
  override ngOnInit() {
    super.ngOnInit();
    this._fetch();
  }

  public next() {
    if (!this._grid || !this.hasNext()) {
      return;
    }
    this._goTo('next');
  }

  public previous() {
    if (!this._grid || !this.hasPrevious()) {
      return;
    }

    this._goTo('previous');
  }

  private _fetch() {
    this.requestState.asked();
    if (!this._grid) {
      return;
    }
    this._registerSubscription(
      this._cursorServices.getCursor$(this.gridId(), this._grid.cursor).subscribe({
        error: () => {
          this.requestState.completed();
        },
        next: data => {
          this.cursorList.set(data);
          this.requestState.completed();
        },
      })
    );
  }

  private _goTo(type: Type) {
    const id = this._getId(type);

    if (!id) {
      return;
    }
    if (type === 'next') {
      this._grid.cursor.next(id ?? '');
    } else {
      this._grid.cursor.previous(id ?? '');
    }
    this.navigation()(id);
  }

  private _getId(type: Type): string | null {
    if (!this._grid) {
      return null;
    }
    const list = this.cursorList();
    const currentId = this._grid.cursor.currentId();
    const currentIndex = list.findIndex(entity => entity.id === currentId);

    if (currentIndex === -1) {
      return null;
    }

    if (type === 'next' && currentIndex < list.length - 1) {
      return list[currentIndex + 1]?.id ?? null;
    }

    if (type === 'previous' && currentIndex > 0) {
      return list[currentIndex - 1]?.id ?? null;
    }

    return null;
  }
}
